export default __webpack_public_path__ + "files/6b50abc0e63b3702f1ae99049c4ff73d.png";